import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  const directionClasses = { asc: 'sort-asc', desc: 'sort-desc', none: 'sort-none' }
  const urlParams = new URLSearchParams(window.location.search)
  const direction = urlParams.get('direction')
  const sortItem = urlParams.get('item')
  const sortTable = urlParams.get('sort')
  const table = document.getElementById(sortTable)
  const { hash } = window.location
  if (!table) return
  const ths = table.getElementsByTagName('th')
  const links = []
  Array.from(ths).forEach((th) => {
    links.push(th.querySelectorAll('a'))
  })
  const possibleItems = []

  Array.from(ths).forEach((th) => {
    possibleItems.push(th.id)
  })

  const hasDirectionProperty = Object.prototype.hasOwnProperty.call(directionClasses, direction)
  const hasSortItemProperty = possibleItems.includes(sortItem)
  if (hasSortItemProperty && hasDirectionProperty) {
    Array.from(ths).forEach((th) => {
      th.classList.remove(directionClasses.desc)
      th.classList.remove(directionClasses.asc)
      if (th.id === sortItem) {
        th.classList.add(directionClasses[direction])
      } else {
        th.classList.add(directionClasses.none)
      }
    })
  }

  links.forEach((link) => {
    if (link.length >= 1) {
      link[0].addEventListener('click', () => {
        window.history.pushState({}, '', decodeURI(hash))
      })
    }
  })
})
